/** Thai strings for this area (English source text -> Thai). */
export const MULTIPLAYER: Record<string, string> = {
  // Main menu (MenuScene)
  'checking the battle server…': 'กำลังเช็กเซิร์ฟเวอร์ต่อสู้…',
  'Math homework p.37': 'การบ้านคณิต หน้า 37',
  'draw monsters instead!!': 'วาดมอนสเตอร์ดีกว่า!!',
  'A Living Notebook RPG': 'เกม RPG ในสมุดที่มีชีวิต',
  'Main menu': 'เมนูหลัก',
  'Start Adventure': 'เริ่มผจญภัย',
  'My Notebook': 'สมุดของฉัน',
  'Battle With Friends': 'สู้กับเพื่อน',
  Options: 'ตัวเลือก',
  'How to Play': 'วิธีเล่น',
  '← start here!': '← เริ่มตรงนี้!',
  'v{version} · made with pencils': 'v{version} · ทำด้วยดินสอ',
  'battle server: online ({storage})': 'เซิร์ฟเวอร์ต่อสู้: ออนไลน์ ({storage})',
  'battle server: offline — single-player works!': 'เซิร์ฟเวอร์ต่อสู้: ออฟไลน์ — เล่นคนเดียวได้นะ!',

  // Battle With Friends (MultiplayerScene)
  '← Back': '← กลับ',
  'Your challenge was declined. Maybe next recess!': 'เพื่อนปฏิเสธคำท้าสู้ ไว้ช่วงพักรอบหน้านะ!',
  'Could not connect': 'เชื่อมต่อไม่ได้',
  'The battle server is offline': 'เซิร์ฟเวอร์ต่อสู้ออฟไลน์อยู่',
  'Online rooms need the Go game server (see README → "Run the backend"). Your adventure, monsters and notebook work fine without it.':
    'ห้องออนไลน์ต้องใช้เซิร์ฟเวอร์เกม Go (ดู README → "Run the backend") ส่วนการผจญภัย มอนสเตอร์ และสมุดของเธอยังเล่นได้ตามปกติ',
  'Try again': 'ลองอีกครั้ง',
  'Play single-player': 'เล่นคนเดียว',
  '● offline': '● ออฟไลน์',
  '● connecting…': '● กำลังเชื่อมต่อ…',
  '● online as {name}': '● ออนไลน์ในชื่อ {name}',
  '● reconnecting…': '● กำลังเชื่อมต่อใหม่…',
  'Connecting to the classroom… (we will put you back in your room automatically)': 'กำลังเชื่อมต่อห้องเรียน… (เดี๋ยวพากลับเข้าห้องเดิมให้เองนะ)',
  'Join the class': 'เข้าห้องเรียน',
  'Signed in as {name}.': 'เข้าระบบในชื่อ {name} แล้ว',
  'Pick a nickname so friends know who they are fighting.': 'ตั้งชื่อเล่นก่อน เพื่อนจะได้รู้ว่ากำลังสู้กับใคร',
  Connect: 'เชื่อมต่อ',
  'My hero: {name} (Lv {level})': 'ฮีโร่ของฉัน: {name} (Lv {level})',
  'Monster: {name}': 'มอนสเตอร์: {name}',
  'Create a hero or draw a monster first!': 'สร้างฮีโร่หรือวาดมอนสเตอร์ก่อนนะ!',
  Fighter: 'นักสู้',
  'Fight as': 'ใช้นักสู้',
  'Something went wrong': 'อุ๊ย มีบางอย่างผิดพลาด',
  'Pick a fighter first.': 'เลือกนักสู้ก่อนนะ',
  'Invite sent to {name}!': 'ส่งคำชวนให้ {name} แล้ว!',
  'Finish your battle first!': 'สู้ให้จบก่อนนะ!',
  'Turn timer seconds': 'เวลาต่อตา (วินาที)',
  '{n}s': '{n} วิ',
  'Max rounds': 'จำนวนรอบสูงสุด',
  'Free stats': 'ค่าพลังอิสระ',
  'Turn timer': 'เวลาต่อตา',
  'Free stats (no budget — practice/teaching)': 'ค่าพลังอิสระ (ไม่จำกัดแต้ม — ไว้ฝึกหรือสอน)',
  'Public · ranked': 'สาธารณะ · จัดอันดับ',
  'Classroom · custom rules': 'ห้องเรียน · ตั้งกติกาเอง',
  CODE: 'รหัส',
  'Room code': 'รหัสห้อง',
  'Create a Room': 'สร้างห้อง',
  'Create a Room (more options)': 'สร้างห้องแบบตั้งค่าเอง',
  'Battle a Friend Now': 'สู้กับเพื่อนเลย',
  'Tap Battle next to a friend, or send a link. The battle starts by itself when they arrive.': 'กด "สู้เลย!" ข้างชื่อเพื่อน หรือส่งลิงก์ให้เพื่อน พอเพื่อนเข้ามา การต่อสู้จะเริ่มเองทันที',
  'Looking for your friends…': 'กำลังหาเพื่อน…',
  'Battle!': 'สู้เลย!',
  'None of your friends is online right now. Send them a room link instead!': 'ตอนนี้ยังไม่มีเพื่อนออนไลน์ ส่งลิงก์ห้องให้เพื่อนแทนได้เลย!',
  'Add friends in Notebook → Friends, or send a room link to anyone.': 'เพิ่มเพื่อนได้ที่ สมุด → เพื่อน หรือส่งลิงก์ห้องให้ใครก็ได้',
  'Make a room and send the link': 'สร้างห้องแล้วส่งลิงก์',
  'Send link to a friend': 'ส่งลิงก์ให้เพื่อน',
  'Send the link: the battle starts as soon as your friend opens it.': 'ส่งลิงก์ไปเลย เพื่อนเปิดเมื่อไหร่ เริ่มสู้ทันที',
  '{name} is here, the battle is starting…': '{name} มาแล้ว กำลังเริ่มสู้…',
  'Battle me in Paper Legends! Room {code}': 'มาสู้กันใน Paper Legends! ห้อง {code}',
  'Link copied! Send it to your friend.': 'คัดลอกลิงก์แล้ว! ส่งให้เพื่อนได้เลย',
  'Could not copy. Tell your friend the code {code} instead.': 'คัดลอกไม่ได้ บอกโค้ด {code} ให้เพื่อนแทนนะ',
  'Room mode': 'โหมดห้อง',
  'Public rooms are ranked: every fighter is scaled into a {budget}-point budget.': 'ห้องสาธารณะมีจัดอันดับ: นักสู้ทุกตัวจะถูกปรับให้อยู่ในงบ {budget} แต้ม',
  'Create Room': 'สร้างห้อง',
  'Join a Room': 'เข้าร่วมห้อง',
  'Type the code your friend wrote on the board:': 'พิมพ์รหัสที่เพื่อนเขียนไว้บนกระดาน:',
  Join: 'เข้าร่วม',
  'Room codes have 6 characters.': 'รหัสห้องมี 6 ตัวนะ',
  connected: 'เชื่อมต่อแล้ว',
  disconnected: 'หลุดการเชื่อมต่อ',
  HOST: 'เจ้าของห้อง',
  '(you)': '(คุณ)',
  'disconnected — waiting for them to come back…': 'หลุดการเชื่อมต่อ — รอเพื่อนกลับมา…',
  'Return to battle': 'กลับไปสู้ต่อ',
  '{name} challenges you!': '{name} ท้าสู้กับคุณ!',
  'Accept!': 'ยอมรับ!',
  Decline: 'ปฏิเสธ',
  'Challenge sent — waiting for {name}…': 'ส่งคำท้าสู้แล้ว — รอ {name} อยู่…',
  'Challenge {name}!': 'ท้าสู้ {name}!',
  'Invite sent to {name} — waiting for them to hop in…': 'ส่งคำชวนให้ {name} แล้ว — รอเพื่อนเข้ามา…',
  'Waiting for a friend to join with the code…': 'รอเพื่อนใส่รหัสเข้ามา…',
  'Room code — tell your friend:': 'รหัสห้อง — บอกเพื่อนเลย:',
  'Copy code': 'คัดลอกรหัส',
  'Code copied!': 'คัดลอกรหัสแล้ว!',
  'Public room · ranked · fair arena budget': 'ห้องสาธารณะ · จัดอันดับ · งบแต้มเท่ากันทุกคน',
  'Classroom room · not ranked · {sec}s turns · {rounds} rounds': 'ห้องเรียน · ไม่จัดอันดับ · ตาละ {sec} วิ · {rounds} รอบ',
  'free stats': 'ค่าพลังอิสระ',
  'Update fighter': 'เปลี่ยนนักสู้',
  'Leave room': 'ออกจากห้อง',

  // Main menu (redesign)
  'A notebook RPG where your drawings come alive': 'เกม RPG ในสมุด ที่ภาพวาดของคุณมีชีวิต',
  'Small drawings.': 'ภาพวาดเล็ก ๆ',
  'Big adventures!': 'การผจญภัยครั้งใหญ่!',
  'Monsters today.': 'วันนี้เป็นมอนสเตอร์',
  'Legends tomorrow!': 'พรุ่งนี้เป็นตำนาน!',
  'Same notebook.': 'สมุดเล่มเดิม',
  'New legends.': 'ตำนานบทใหม่',
  'ERASE FEAR': 'ลบความกลัว',
  'Notebook shortcuts': 'ทางลัดในสมุด',
  // World chat (ui/worldChat.ts)
  'World chat': 'แชทโลก',
  'Be kind! Rude words are hidden, and ⚑ reports a message to a moderator.': 'พูดกันดีๆ นะ! คำหยาบจะถูกซ่อน และกด ⚑ เพื่อรายงานข้อความให้ผู้ดูแล',
  Messages: 'ข้อความ',
  Message: 'ข้อความ',
  'Say something nice…': 'พิมพ์อะไรดีๆ หน่อย…',
  Send: 'ส่ง',
  'Report this message': 'รายงานข้อความนี้',
  'Thanks — a moderator will take a look.': 'ขอบคุณนะ ผู้ดูแลจะเข้าไปดูให้',
  'No messages yet. Say hi!': 'ยังไม่มีข้อความ ทักทายกันหน่อย!',
};
